import React from 'react';
import { Box, Pagination, Typography } from '@mui/material';
import type { IParticipantPaginationProps } from '../../interfaces';

/** Shared pager for every participant tab built with MUI Pagination. */
export const ParticipantPagination = ({
  page,
  totalCount,
  pageSize,
  onPageChange,
}: IParticipantPaginationProps) => {
  const totalPages = Math.ceil(totalCount / pageSize);
  if (totalPages <= 1) return null;

  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalCount);

  return (
    <Box
      component="nav"
      aria-label="Pagination"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        py: 2.5,
      }}
    >
      <Typography variant="caption" color="text.secondary">
        Showing{' '}
        <Typography component="span" variant="caption" fontWeight={600} color="text.primary">
          {from}–{to}
        </Typography>{' '}
        of{' '}
        <Typography component="span" variant="caption" fontWeight={600} color="text.primary">
          {totalCount}
        </Typography>
      </Typography>

      <Pagination
        count={totalPages}
        page={page}
        onChange={(_, p) => onPageChange(p)}
        color="primary"
        shape="rounded"
        size="small"
        sx={{
          '& .MuiPaginationItem-root': {
            borderRadius: '8px',
            fontWeight: 600,
          },
        }}
      />
    </Box>
  );
};
